import { render, staticRenderFns } from "./TransactionHistoryStand.vue?vue&type=template&id=66bd9d5a&scoped=true&"
import script from "./TransactionHistoryStand.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryStand.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistoryStand.vue?vue&type=style&index=0&id=66bd9d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd9d5a",
  null
  
)

export default component.exports